'use client';

import { c as _c } from "react/compiler-runtime";
import { usePrV2ViewPreferencesStore } from '@/lib/stores/pr-v2-view-preferences-store';
import { useZenModeStore } from '@/lib/stores/zen-mode-store';
export type PrV2SkeletonLayout = {
  chatSidebarOpen: boolean;
  showAiSections: boolean;
};

/**
 * The persisted/in-session viewer state that shapes the PR page's macro layout,
 * resolved once for skeleton rendering so loading states match the real first
 * paint. Server render paths (the PR layout's document-load fallback) omit the
 * layout instead — they cannot know client state and keep the historical
 * default rendering.
 */
export function usePrV2SkeletonLayout() {
  const $ = _c(3);
  const chatSidebarOpen = usePrV2ViewPreferencesStore(_temp);
  const isZenMode = useZenModeStore(_temp2);
  const t0 = !isZenMode;
  let t1;
  if ($[0] !== chatSidebarOpen || $[1] !== t0) {
    t1 = {
      chatSidebarOpen,
      showAiSections: t0
    };
    $[0] = chatSidebarOpen;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function _temp2(state_0) {
  return state_0.isZenMode;
}
function _temp(state) {
  return state.rightSidebarOpen;
}